export default __webpack_public_path__ + "static/media/Ms.Nitya_George.15689bef.png";